import { Spacing } from '@doordash/design-language';

var GridContainerSpacing = Spacing;
var GridContentSpacing = Spacing;
var GridContainerAlignment;

(function (GridContainerAlignment) {
  GridContainerAlignment["Start"] = "start";
  GridContainerAlignment["Center"] = "center";
  GridContainerAlignment["End"] = "end";
})(GridContainerAlignment || (GridContainerAlignment = {}));

var GridContentWidth;

(function (GridContentWidth) {
  GridContentWidth["Full"] = "full";
  GridContentWidth["Half"] = "half";
  GridContentWidth["Third"] = "third";
  GridContentWidth["Quarter"] = "quarter";
  GridContentWidth[GridContentWidth["Single"] = 1] = "Single";
  GridContentWidth[GridContentWidth["Double"] = 2] = "Double";
  GridContentWidth[GridContentWidth["Triple"] = 3] = "Triple";
  GridContentWidth["Hidden"] = "hidden";
})(GridContentWidth || (GridContentWidth = {}));

export { GridContainerAlignment, GridContainerSpacing, GridContentSpacing, GridContentWidth };
